import React from 'react';
import './AboutUsPage.css';
import Image from "../../../assets/images/about_us_img.png";
import { useTranslation } from "react-i18next";


function AboutUsPage() {
    const { t } = useTranslation();
    return (
        <div className="about-us-page">
            <h1> About us</h1>
            <div className="about-us-image-container">
                <div>
                    <p> {t('Welcome to')} <strong>Abougabal Constructions</strong>. {t("Together we will design and materialize your dream house, working place, or business premises. Since 2004, we undertake housing and business constructions, as well as real estate renovations and hotels. Our high-standard rules are the precise design, the detailed and budgeted planning as well as the diligent execution of each customized project.")}
                    </p>
                    <p>
                        {t("We cooperate with a great team of technicians covering the whole range of any construction such as:")}
                    </p>
                </div>
                <img src={Image} alt="About us image" className="about-us-image"/>
            </div>
            <div className="about-us-image-container-mobile">
                <div>
                    <p> {t('Welcome to')} <strong>Abougabal Constructions</strong>. {t("Together we will design and materialize your dream house, working place, or business premises. Since 2004, we undertake housing and business constructions, as well as real estate renovations and hotels. Our high-standard rules are the precise design, the detailed and budgeted planning as well as the diligent execution of each customized project.")}
                    </p>
                    <img src={Image} alt="About us image" className="about-us-image-mobile"/>
                    <p>
                        {t("We cooperate with a great team of technicians covering the whole range of any construction such as:")}
                    </p>
                </div>
            </div>

            <ul>
                <li>{t("Commercial constructions & building works")}</li>
                <li>{t("Electrical and hydraulic constructions")}</li>
                <li>{t("Design and renovation of kitchens and bathrooms")}</li>
                <li>{t("Heating and natural gas infrastructure")}</li>
                <li>{t("Customized plasterboard constructions and custom designs")}</li>
                <li>{t("Lightning design (custom in-house LED design, garden lighting)")}</li>
                <li>{t("Painting services & special commissions (kid’s spaces, decorative walls)")}</li>
                <li>{t("Fireplace construction with specialized technicians")}</li>
                <li>{t("Carpentry services (wooden floors, kitchen spaces)")}</li>
                <li>{t("smartHome solutions (password access monitors, cameras)")}</li>
                <li>{t("Garden services")}</li>
            </ul>
            <div className="justified-content">
                <p>
                    {t("Our firm delivers certainty in four critical areas: schedule, cost, quality, and safety. With more than 150 completed projects, we have a vast experience in house rennovations, restoration and redesigning of any business place and hotel facility. Combining imagination and knowledge with high standard materials and excellent collaborations, we create high quality works with an aesthetic value.")}
                </p>
                <p>
                    {t("We also undertake special short-term rental construction projects, with special technical requirements. We put emphasis on the safety and cost-efficiency of your property by installing customized equipment, such as: automatic door-locks with passcode, air-condition on/off switch to minimize electricity usage, safety cameras, and smart home installations.")}
                </p>
                <p>
                    {t("We love to suggest functional and budgeted solutions, so that you can choose the ones that meet your requirements. You may contact us for a free site-visit and offer!")}
                </p>
            </div>
        </div>
    );
}

export default AboutUsPage;
